<template>
    <div class="search-input">
        <input type="text" :placeholder="placeholderVal" :value="s"  @input="updateInternalValue">
        <button type="button" class="search-input__reset" :class="{ 'show' : s !== ''}" @click="resetQuery"></button>
    </div>
</template>

<script>
import {translate} from "@/helpers/helpers";

import _debounce from "lodash/debounce";

export default {
    name: "search",
    props: ['s', 'placeholder'],
    computed: {
        placeholderVal() {
            return this.placeholder || this.translate('search');
        }
    },
    methods: {
        translate: translate,
        resetQuery() {
            this.$emit('onReset');
        },
        updateInternalValue (event) {
            this.updateValue(event.target.value)
        },
        updateValue: _debounce(function (value) {
            this.$emit('update:s', value);
        }, 400),
    }
}
</script>

<style scoped>

</style>